var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.83887 0.150391L7.85645 0.154297V0.155273C7.93833 0.162622 8.01758 0.193571 8.0791 0.250977L11.3369 3.29102C11.4087 3.35704 11.4513 3.44965 11.4502 3.54883V13.0986C11.4501 13.3036 11.274 13.4506 11.082 13.4502V13.4512H0.515625C0.323732 13.4501 0.150677 13.3027 0.149414 13.0996V0.504883C0.148733 0.300292 0.323137 0.151435 0.515625 0.150391H7.83887ZM0.884766 12.7441H10.7139V3.89941H7.82129C7.62861 3.89853 7.45518 3.74981 7.45508 3.5459V3.39551H7.45605V0.857422H0.884766V12.7441ZM8.18945 3.19238H10.1758L8.18945 1.33789V3.19238Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file_icon.59ae2914769c91dd413b6da75c23cda1.svg";
export { ForwardRef as ReactComponent };